module.exports = __webpack_public_path__ + "img/circleAlert.3cfd6748.svg";